module.exports = __webpack_public_path__ + "static/media/Diabete.31400a5a.jpg";